import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { ToolbarButtonNew, ToolbarButtonOld } from './toolbarButton.styled';

if (typeof require.context === 'undefined') {
  require.context = () => ({ keys: () => ['./dummy.resource'] });
}

export class EditorToolbarButton extends React.Component {
  onClick = e => {
    const { button, store } = this.props;
    e.preventDefault();
    button.handleClick(store);
  };

  render() {
    const { isFloating, button, store } = this.props;
    const { value } = store;
    const { type, active } = button;
    const ToolbarButton = isFloating ? ToolbarButtonOld : ToolbarButtonNew;

    return (
      <ToolbarButton data-active={active(value)} onMouseDown={this.onClick}>
        <Icon name={type.toLowerCase()} />
      </ToolbarButton>
    );
  }
}

EditorToolbarButton.propTypes = {
  store: PropTypes.object,
  button: PropTypes.object,
  isFloating: PropTypes.bool,
};
